<template>
  <Sales 
    :fetchItems=fetchItems
    :showWarranties=false
  />
</template>

<script>
import { sale } from "@/api";
import Sales from "@/components/sales/Sales.vue"

export default {
  name: "WarrantiedSalesPage",
  components: {
    Sales
  },
  methods: {
    fetchItems(search, itemsPerPage, page) {
      return sale.getWarrantiedSalesList(search, itemsPerPage, page);
    },
  },
};
</script>